// extracted by mini-css-extract-plugin
export default {"cls1":"Popover-cls1__bf04b9ddb146f331ace1","cls2":"Popover-cls2___f0769b3bbfe5f4c9d28 Popover-cls1__bf04b9ddb146f331ace1"};